// tldr-cards.js
// Progressive enhancement for the TLDR page: make the whole card follow its
// inner arrow link on a mouse click. Accessibility is unchanged — the arrow
// stays the only real anchor (keyboard + screen readers use it); this just adds
// mouse-click convenience, and respects text selection and modifier/middle
// clicks so links still open in a new tab when expected.

function initTldrCards() {
	const cards = document.querySelectorAll(
		'.all-sections .related-tag-section-item'
	);
	if (!cards.length) return;

	cards.forEach((card) => {
		const link = card.querySelector('.link-arrow a[href]');
		if (!link) return;

		// Marks the card as JS-clickable so the CSS pointer/hover affordance
		// only shows when this enhancement is actually active.
		card.classList.add('is-clickable');

		card.addEventListener('click', (e) => {
			// Let real interactive elements behave normally.
			if (e.target.closest('a, button')) return;
			// Never hijack an active text selection.
			const selection =
				window.getSelection && window.getSelection().toString();
			if (selection && selection.length) return;

			const href = link.getAttribute('href');
			if (!href) return;

			if (e.metaKey || e.ctrlKey || e.shiftKey) {
				window.open(href, '_blank', 'noopener');
			} else {
				window.location.href = href;
			}
		});

		// Middle-click → open in a new tab, matching normal link behaviour.
		card.addEventListener('auxclick', (e) => {
			if (e.button !== 1) return;
			if (e.target.closest('a, button')) return;
			const href = link.getAttribute('href');
			if (href) window.open(href, '_blank', 'noopener');
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initTldrCards);
} else {
	initTldrCards();
}
